import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { ButtonComponent } from '@shared/components/button/button.component';
import { InputComponent } from '@shared/components/input/input.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputComponent, ReactiveFormsModule, NgClass, ButtonComponent, TooltipDirective],
  selector: 'aux-notes',
  styleUrls: ['notes.component.scss'],
  templateUrl: 'notes.component.html',
})
export class NotesComponent implements OnInit {
  @Output() cancelNotes = new EventEmitter();
  classListForEdit = 'py-0.5 mt-[5px]';
  @Input() disabledTooltipText = '';
  editMode = false;
  @Input() hasEditPermission = false;
  @Input() notesControl = new FormControl();
  @ViewChild('notesTextArea') notesTextArea!: InputComponent;
  @Input() placeholder = 'Add a note...';
  @Output() saveNotes = new EventEmitter();
  @Input() title = '';

  ngOnInit(): void {
    this.notesControl.disable();
    this.classListForEdit = this.hasEditPermission
      ? this.classListForEdit
      : `${this.classListForEdit} cursor-not-allowed`;
  }

  cancel(): void {
    this.cancelNotes.emit();
    this.editMode = false;
  }

  edit(): void {
    this.editMode = true;
    setTimeout(() => {
      const end = this.notesTextArea.input?.nativeElement.value.length || 0;

      this.notesTextArea.input?.nativeElement.focus();
      this.notesTextArea.input?.nativeElement.setSelectionRange(end, end);
    }, 0);
  }

  onSave(): void {
    this.saveNotes.emit();
    this.editMode = false;
  }
}
